import { Injectable } from '@angular/core';
import { GlobalConstants } from '@venecia/constants';

@Injectable({ providedIn: 'root' })
export class StorageService {

    private readonly storage: Storage = sessionStorage;

    get<T>(key: string): T | null {
        const raw: string | null = this.storage.getItem(key);

        if (raw === null) {
            return null;
        }

        try {
            return JSON.parse(raw) as T;
        } catch {
            return null;
        }
    }

    set<T>(key: string, value: T): void {
        this.storage.setItem(key, JSON.stringify(value));
    }

    remove(key: string): void {
        this.storage.removeItem(key);
    }

    clear(): void {
        const fixedTheme = this.get(GlobalConstants.THEME_KEY);
        const fixedLang = this.get(GlobalConstants.LANG_KEY);

        this.storage.clear();

        this.set(GlobalConstants.THEME_KEY, fixedTheme);
        this.set(GlobalConstants.LANG_KEY, fixedLang);
    }

    exists(key: string): boolean {
        return this.storage.getItem(key) !== null;
    }
}
